import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class CargandoService {
    // private sub = new BehaviorSubject<boolean>(false);
    spinners = new Map<string, BehaviorSubject<boolean>>();
    constructor() { }

    add(id: string) {
        this.spinners.set(id, new BehaviorSubject<boolean>(false));
    }

    remove(id: string) {
        this.spinners.delete(id);
    }

    start(id: string) {
        this.spinners.get(id).next(true);
    }

    stop(id: string) {
        this.spinners.get(id).next(false);
    }

    get(id: string) {
        return this.spinners.get(id).asObservable();
    }

}